var _mask, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarHospitalOff = function SvgNavbarHospitalOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "navbar-hospital-off_svg__a",
    width: 18,
    height: 22,
    x: 3,
    y: 1,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3 1.5h18v21H3z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#navbar-hospital-off_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M11.969 20.638c-1.664-1.07-7.332-5.12-7.332-10.643 0-3.832 3.303-6.95 7.363-6.95s7.363 3.118 7.363 6.95c0 4.906-5.744 9.442-7.394 10.643M12 1.5c-4.963 0-9 3.81-9 8.495 0 7.304 8.228 12.049 8.579 12.247l.455.258.435-.287C12.818 21.983 21 16.5 21 9.995 21 5.311 16.963 1.5 12 1.5",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M12.75 6.781h-1.5v2.25H9v1.5h2.25v2.25h1.5v-2.25H15v-1.5h-2.25z",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarHospitalOff;